import React from 'react';
import { Link } from 'react-router-dom';
import s from '../componentsStlyes/LandingPag.module.css'
import imagen from '../Imagen/Screenshot_18.png'


export default function LandingPage(){
    return ( 
        <div className={s.fondo}>

                <div>
                    {/* <img className={s.imagen} src={imagen}></img> */}
                    <h1 className={s.nombrePagina}>Menú App!</h1>
                </div>
                <div className={s.div}>
                        <div className={s.subcarta}>
                            <h1 className={s.titulo}> App Menús</h1>
                            
                            <h5 className={s.contenido}>¡Look at the recipes that we have!</h5>
                            <Link to ='/Cards'>
                            <button className={s.boton}>Get into</button>
                            </Link>
                        </div>
                        <div className={s.subcarta}>
                                <h1 className={s.titulo}>   Create recipe!</h1>
                                
                                <h5 className={s.contenido}>Create your own food recipe!</h5>
                                <Link to='/recipe'>
                                <button className={s.boton}>Create</button>
                                </Link>
                        </div>
                </div>
        </div>
    )
}